<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 2.40039C17.3019 2.40039 21.6006 6.69811 21.6006 12C21.6006 16.9083 17.9166 20.9552 13.1631 21.5293V14.9336H15.7607L16.2988 12H13.1631V10.9629C13.1631 9.41271 13.7718 8.81545 15.3457 8.81543C15.834 8.81543 16.2274 8.8278 16.4541 8.85156V8.85059L16.4551 8.85156V6.19238C16.4433 6.18913 16.4306 6.18685 16.418 6.18359C16.3727 6.17192 16.3222 6.15896 16.2666 6.14746L16.0332 6.10449C15.5286 6.02071 14.8244 5.95414 14.3682 5.9541C14.2677 5.9541 14.1684 5.95503 14.0713 5.95801C13.3932 5.97879 12.7973 6.07227 12.2812 6.24121C11.5488 6.48107 10.9771 6.87324 10.5586 7.42383C10.4717 7.53811 10.3911 7.65906 10.3174 7.78711C10.2102 7.97324 10.1169 8.17411 10.0371 8.38965C9.98388 8.53343 9.9367 8.6838 9.89551 8.84082C9.87493 8.91926 9.85548 8.99929 9.83789 9.08105C9.80264 9.24491 9.77337 9.41548 9.75 9.59277C9.73834 9.68124 9.72845 9.77145 9.71973 9.86328C9.69355 10.1389 9.68066 10.4301 9.68066 10.7363V12H7.70117V14.9336H9.68066V21.3174C5.49946 20.2797 2.40039 16.5019 2.40039 12C2.40039 6.69811 6.69811 2.40039 12 2.40039Z"
      fill="currentColor"
    />
  </svg>
</template>
